import 'mapbox-gl/dist/mapbox-gl.css';

// import { Bird, Flower } from 'lucide-react';
import React, { useEffect, useRef } from 'react';
import MapBoxMap, { type MapRef,Marker } from 'react-map-gl/mapbox';

import { config } from '@/config/loader.js';
import assetIcon from '@/images/portfolio-map-marker.png';

import MiniSpinner from '../../asset/components/mini-spinner.js';
import LandCoverMapLayer, { type LandCoverCategory } from '../../free-tool/map-layers/LandCoverMapLayer.js';

interface SiteLocationMapProps {
  siteLat: number;
  siteLng: number;
  tiff: string | null;
  loading: boolean;
  hoveredLandCover: LandCoverCategory | null;
  setHoveredLandCover: (v: LandCoverCategory | null) => void;
}

export function SiteLocationMap({ siteLat, siteLng, tiff, loading, hoveredLandCover, setHoveredLandCover }: SiteLocationMapProps): React.JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<MapRef>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const observer = new ResizeObserver(() => { mapRef.current?.resize(); });
    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  const initialViewState = React.useMemo(() => {
    return { latitude: siteLat, longitude: siteLng, zoom: 13.5 };
  }, [siteLat, siteLng]);

  return (
    <div ref={containerRef} style={{ position: 'relative', width: '100%', height: '100%' }} onMouseLeave={() => setHoveredLandCover(null)}>
      {loading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center" style={{ backgroundColor: 'rgba(242,236,224,0.6)' }}>
          <MiniSpinner />
        </div>
      )}
      <MapBoxMap
        ref={mapRef}
        mapboxAccessToken={config.mapboxAccessToken}
        initialViewState={initialViewState}
        style={{ width: '100%', height: '100%' }}
        mapStyle="mapbox://styles/mapbox/satellite-streets-v12"
        
        attributionControl={false}
        dragPan={false}
        dragRotate={false}
        scrollZoom={false}
        doubleClickZoom={false}
        touchZoomRotate={false}
        keyboard={false}
      >
        <LandCoverMapLayer
          tiff={tiff}
          hoveredLandCover={hoveredLandCover}
          setHoveredLandCover={setHoveredLandCover}
          opacity={0.1}
        />
        <Marker latitude={siteLat} longitude={siteLng} anchor="center">
          <img src={assetIcon} style={{ width: 32, height: 32, display: 'block' }} />
        </Marker>
      </MapBoxMap>
    </div>
  );
}
